// src/components/MapPicker.js
import { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix missing marker icons in CRA builds
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function ClickHandler({ onSelect }) {
  useMapEvents({ click: (e) => onSelect(e.latlng.lat, e.latlng.lng) });
  return null;
}

function RecenterMap({ lat, lng }) {
  const map = useMapEvents({});
  useEffect(() => {
    if (lat && lng) map.setView([lat, lng], map.getZoom());
  }, [lat, lng, map]);
  return null;
}

export default function MapPicker({ lat, lng, onSelect, onClose }) {
  const centerLat = lat || 20.5937;
  const centerLng = lng || 78.9629;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-wide" onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>📍 Pick Store Location</h3>
          <button className="secondary-btn" onClick={onClose}>Done</button>
        </div>
        <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: 12 }}>
          Tap anywhere on the map to place your store pin.
        </p>
        <div style={{ height: 400, borderRadius: 8, overflow: 'hidden' }}>
          <MapContainer center={[centerLat, centerLng]} zoom={13} style={{ height: '100%', width: '100%' }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <ClickHandler onSelect={onSelect} />
            {lat && lng && <Marker position={[lat, lng]} />}
            {lat && lng && <RecenterMap lat={lat} lng={lng} />}
          </MapContainer>
        </div>
        {lat && lng && (
          <p style={{ marginTop: 10, fontSize: '0.85rem', color: '#16a34a', fontWeight: 500 }}>
            ✅ Selected: {parseFloat(lat).toFixed(5)}, {parseFloat(lng).toFixed(5)}
          </p>
        )}
      </div>
    </div>
  );
}
